import React from "react";

import "./ContactForm.css";

const input = props => {
  let inputElement = null;
  let inputClasses = ["form-input"];

  if (props.invalid && props.shouldValidate && props.focused) {
    inputClasses.push("invalid");
  }

  switch (props.type) {
    case "input":
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.config}
          value={props.value}
          onChange={props.changed}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea
          className={inputClasses.join(" ")}
          {...props.config}
          value={props.value}
          onChange={props.changed}
        />
      );
      break;
    case "select":
      inputElement = (
        <select
          className={inputClasses.join(" ")}
          value={props.value}
          onChange={props.changed}
        >
          {props.config.options.map(option => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    default:
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.config}
          value={props.value}
          onChange={props.changed}
        />
      );
  }

  return (
    <div>
      {inputElement}
      <label htmlFor={props.label} className={props.label + " form-label"}>
        {props.config.placeholder}
      </label>
    </div>
  );
};

export default input;



// WEBPACK FOOTER //
// ./src/components/ContactForm/Input.js